import React from "react"

import SEO from "../components/seo"
import Link from "../utils/link"

// NOTE: Placeholder legal copy below. Replace the body text with Wingspan
// Capital's legal-approved Disclaimer before go-live.
import "./legal.scss"

const Disclaimer = () => (
  <>
    <SEO
      title="Disclaimer"
      description="Important information and disclaimer regarding the use of the Wingspan Capital website."
      path="/disclaimer"
    />
    <article className="legal">
      <h1 className="legal__title">Disclaimer</h1>
      <p className="legal__updated">Last updated: June 2026</p>

      <section className="legal__section">
        <p>
          The information on this website is provided by Wingspan Capital
          (&ldquo;Wingspan&rdquo;) for general information purposes only. While
          we endeavour to keep the information up to date and correct, we make
          no representations or warranties of any kind, express or implied,
          about the completeness, accuracy, reliability or suitability of the
          information contained on this website.
        </p>
      </section>

      <section className="legal__section">
        <h2>No financial advice</h2>
        <p>
          Nothing on this website constitutes financial, investment, legal or
          taxation advice, nor a recommendation or offer to buy or sell any
          financial product. The information does not take into account your
          objectives, financial situation or needs. You should obtain
          independent professional advice before making any financial
          decision.
        </p>
      </section>

      <section className="legal__section">
        <h2>Past performance</h2>
        <p>
          Past performance is not a reliable indicator of future performance.
          The value of investments can rise and fall, and you may not recover
          the amount originally invested.
        </p>
      </section>

      <section className="legal__section">
        <h2>Third-party links</h2>
        <p>
          This website may contain links to external websites that are not
          provided or maintained by Wingspan. We do not guarantee the accuracy,
          relevance or completeness of any information on these external
          websites.
        </p>
      </section>

      <section className="legal__section">
        <h2>Limitation of liability</h2>
        <p>
          To the maximum extent permitted by law, Wingspan will not be liable
          for any loss or damage of any kind arising from the use of, or
          reliance on, the information contained on this website.
        </p>
      </section>

      <section className="legal__section">
        <h2>Contact us</h2>
        <p>
          If you have any questions about this Disclaimer, please{" "}
          <Link to="/contact">contact us</Link>.
        </p>
      </section>
    </article>
  </>
)

export default Disclaimer
